"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHistory = void 0;
const event_history_schema_1 = require("./event-history.schema");
const base_model_1 = require("../base-model");
class EventHistory extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return event_history_schema_1.eventHistorySchema;
    }
}
exports.EventHistory = EventHistory;
